import request from "@/utils/request";

export function getChannels() {
  return request({
    url: `/api/guidebookv3/admin/channels/`,
    method: `get`,
  });
}

export function getChannelsId(id, params) {
  return request({
    url: `/api/guidebookv3/admin/channels/${id}/`,
    method: `get`,
    params,
  });
}

export function putChannels(id, data) {
  return request({
    url: `/api/guidebookv3/admin/channels/`,
    method: `post`,
    data,
  });
}
